import { ShareAccessPermission } from './../models/shared-access-details';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sharePermissionStatus',
    standalone: false
})
export class SharePermissionsPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const a = ShareAccessPermission[value];
    if (a) {
      const b = a
        .replace(/([A-Z])/g, ' $1')
        .replace(a.substring(0, 1), a.substring(0, 1).toUpperCase());
      return b;
    }
    return '';
  }
}
